/**
 * @file en.ts
 * @description English translations for TournamentJoinPayment components (Task 30.3)
 */

export const recoveryTranslations = {
  title: 'Resume your payment?',
  description: 'You have an unfinished payment for this tournament.',
  resumeButton: 'Resume Payment',
  dismissButton: 'Start New',
  amountLabel: 'Amount: {amount} {currency}',
  expiresIn: 'Expires in {time}',
  ariaLabel: 'You have an existing payment session. Would you like to resume?',
  resumeAriaLabel: 'Resume payment',
  dismissAriaLabel: 'Dismiss and start new payment',
};

export const tournamentJoinPaymentTranslations = {
  defaultLabel: 'Pay & Join',
  loadingLabel: 'Processing...',
  errorPrefix: 'Payment error:',
  stakeLabel: 'Entry fee: {amount} {currency}',
  freeLabel: 'No Entry Fee',
};

export type RecoveryTranslations = typeof recoveryTranslations;
export type TournamentJoinPaymentTranslations = typeof tournamentJoinPaymentTranslations;
